import React, { useEffect, useState } from 'react';
import { QuestionarioPerfilInvestimentoService } from '@services';
import { useSelector } from 'react-redux';

export const ResultadoQuestionario = ({ matricula }) => {
  const [perfilIdentificado, setPerfilIdentificado] = useState();
  const { token } = useSelector((state) => state.user);

  const identificaPerfil = async () => {
    const questionarioService = new QuestionarioPerfilInvestimentoService();
    const perfil = await questionarioService.getResultadoQuestionario(
      matricula,
      token
    );
    setPerfilIdentificado(perfil);
  };

  useEffect(() => {
    identificaPerfil();
  });

  return (
    <div className="row mt-32">
      <div className="col-12 col-md-12 col-lg-12 col-xl-12">
        <div className="card-borderless">
          <div className="card-body">
            <h3 className="ts-20 fw-bold text-muted mb-2">
              Perfil de investimento identificado:
            </h3>
            <h1 className="ts-32 fw-bold text-grey mb-3">
              {perfilIdentificado}
            </h1>
            <p className="ts-14 text-muted lh-lg">
              Você pode alterar o seu perfil atual para o identificado no
              questionario
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};
